module.exports = __webpack_public_path__ + "media/images/courseware_completion_status_past_due-cc81ea24a195efcdd8bc629cf08e1def.svg";